import { FareComposition } from '../../types/api/v1/obt/rail/rail_common';

const getIsSplitTicket = (fareComposition?: FareComposition): boolean => {
  return fareComposition === FareComposition.DIRECT_SPLIT || fareComposition === FareComposition.INTERCHANGE_SPLIT;
};

export default getIsSplitTicket;
